<template>
    <div class="goodListSetting">
        <tab @getTab="getTab"></tab>
        <div id='content' v-if="status === 'content'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.tabConfig.title}} ({{setTingObj.tabConfig.list[setTingObj.tabConfig.type].name}})</span>
                <radio :list="setTingObj.tabConfig.list" :type="setTingObj.tabConfig.type" @change="updateTabConfig"></radio>
            </div>
            <template v-if="setTingObj.tabConfig.type == 0">
                <div class='headerSerc-item'>
                    <span>{{setTingObj.selectConfig.title}}</span>
                    <searchCategory :setTingObj="setTingObj"></searchCategory>
                </div>
                <div class='headerSerc-item'>
                    <span>{{setTingObj.numConfig.title}}</span>
                    <el-input style="margin-top: 10px" size="small" v-model="setTingObj.numConfig.val"></el-input>
                </div>
            </template>
            <template v-else>
                <div class='headerSerc-item'>
                    <span>{{setTingObj.selectConfig.title}}</span>
                    <searchProduct :setTingObj="setTingObj"></searchProduct>
                </div>
            </template>
            <div class='headerSerc-item'>
                <div>
                    <span style="margin-right: 10px;line-height: 30px">{{setTingObj.titleShow.title}}</span> <el-switch v-model="setTingObj.titleShow.val"></el-switch>
                </div>
                <div>
                    <span style="margin-right: 10px;line-height: 30px">{{setTingObj.opriceShow.title}}</span> <el-switch v-model="setTingObj.opriceShow.val"></el-switch>
                </div>
                <div>
                    <span style="margin-right: 10px;line-height: 30px">{{setTingObj.priceShow.title}}</span> <el-switch v-model="setTingObj.priceShow.val"></el-switch>
                </div>
            </div>
        </div>
        <div id='style' v-if="status ==='style'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.itemStyle.title}} ({{setTingObj.itemStyle.list[setTingObj.itemStyle.type].val}})</span>
                <radio :list="setTingObj.itemStyle.list" :type="setTingObj.itemStyle.type" @change="updateItemStyle"></radio>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.bgStyle.title}} ({{setTingObj.bgStyle.list[setTingObj.bgStyle.type].val}})</span>
                <radio :list="setTingObj.bgStyle.list" :type="setTingObj.bgStyle.type" @change="updateBgStyle"></radio>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.conStyle.title}} ({{setTingObj.conStyle.list[setTingObj.conStyle.type].val}})</span>
                <radio :list="setTingObj.conStyle.list" :type="setTingObj.conStyle.type" @change="updateConStyle"></radio>
            </div>
            <div class="headerSerc-item">
                <span>{{setTingObj.bgColorImg.title}}</span>
                <bgColorImg :bgColorImg="setTingObj.bgColorImg"></bgColorImg>
            </div>
            <div class="headerSerc-item">
                <span>{{setTingObj.txtBgColor.title}}</span>
                <color :colorObj="setTingObj.txtBgColor"></color>
            </div>
            <div class="headerSerc-item">
                <span>{{setTingObj.fontColor.title}}</span>
                <color :colorObj="setTingObj.fontColor"></color>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.prConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.prConfig"></sliderAndInput>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.mbConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.mbConfig"></sliderAndInput>
            </div>
        </div>
    </div>
</template>

<script>
import tab from '@/components/decoration/common/tab.vue';
import radio from '@/components/decoration/common/radio.vue';
import sliderAndInput from '@/components/decoration/common/sliderAndInput.vue';
import bgColorImg from '@/components/decoration/common/bgColorImg.vue';
import color from '@/components/decoration/common/color.vue';
import searchCategory from '@/components/decoration/common/searchCategory.vue';
import searchProduct from '@/components/decoration/common/searchProduct.vue';

export default {
    components: { color, sliderAndInput, radio, tab, bgColorImg, searchCategory, searchProduct },
    data(){
        return{
            status: 'content'
        }
    },
    props: {
        setTingObj: {
            type: Object,
            default: {}
        }
    },
    methods:{
        getTab(e){
            this.status = e
        },
        updateItemStyle(type){
            this.setTingObj.itemStyle.type = type
        },
        updateTabConfig(type){
            this.setTingObj.tabConfig.type = type
            this.setTingObj.selectConfig.val = ""
            this.setTingObj.goodsList.list = [
                {
                    id: "",
                    name: "小米智能保温杯Ti2商务便携男女士大容量茶杯纯钛茶水分离杯w847",
                    pic: "",
                    oprice: "99",
                    price: "79"
                }
            ]
        },
        updateBgStyle(type){
            this.setTingObj.bgStyle.type = type
        },
        updateConStyle(type){
            this.setTingObj.conStyle.type = type
        },
    }
}
</script>

<style scoped lang="scss">

</style>